angular.module('gus-registry', ['core'])
    .factory('GusRegistry', function ($resource) {
        return $resource('/crm/api/gus-registry', {}, {
            search: {method: 'GET', isArray: true, url: "/crm/api/gus-registry/search"},
        })
    })
    .service('GusService', function ($rootScope, toastr, modals, GusRegistry, $q) {
        this.search = nip => {
            let deferred = $q.defer()
            if (nip == null || nip === "") {
                toastr.warning("Uzupełnij pole NIP")
                deferred.reject("Not found")
                return deferred.promise
            }
            if (nip.length > 2 && nip.substring(0, 2) === "PL") {
                nip = nip.substring(2)
            }

            GusRegistry.search({nip: nip}).$promise
                .then(resultList => {
                    if (resultList.length === 0) {
                        toastr.warning("Nie znaleziono danych dla numeru NIP: " + nip)
                        deferred.reject("Not found")
                    } else {
                        let chooseModel = {
                            nip: nip,
                            items: resultList
                        }
                        modals.open('app/gus-registry/choose-modal.html', 'GusRegistryChooseDialogController', chooseModel, {size: 'lg'}, "$ctrl")
                            .then(item => deferred.resolve(item))
                            .catch(() => deferred.reject("cancelled"))
                    }
                })
                .catch(() => deferred.reject("error"))

            return deferred.promise
        }
    })
    .controller('GusRegistryChooseDialogController', function (data, $uibModalInstance) {
        this.items = data.items
        this.nip = data.nip

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.pick = item => $uibModalInstance.close(item)
    })
